import { render, staticRenderFns } from "./ManufacturingLicence.vue?vue&type=template&id=22a75591&scoped=true"
import script from "./ManufacturingLicence.vue?vue&type=script&lang=js"
export * from "./ManufacturingLicence.vue?vue&type=script&lang=js"
import style0 from "./ManufacturingLicence.vue?vue&type=style&index=0&id=22a75591&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a75591",
  null
  
)

export default component.exports